
import React, { useContext } from 'react';
import { SettingsSearchContext } from './SettingsContext';
import { InfoPopup } from './InfoPopup';
import { STUDIO_THEME } from './StudioTheme';

interface SectionLabelProps {
  children?: React.ReactNode;
  icon?: string;
  darkMode: boolean;
  tooltip?: string;
  settingKey?: string;
  modes?: string[];
}

export const SectionLabel: React.FC<SectionLabelProps> = ({ children, icon, darkMode, tooltip, settingKey, modes }) => {
  const searchQuery = useContext(SettingsSearchContext);
  
  if (searchQuery) return null; // Flatten list when searching

  return (
    <div className={`w-full flex items-center gap-3 ${STUDIO_THEME.spacing.sectionGap}`}>
      <div className={`flex-1 h-px ${darkMode ? 'bg-white/5' : 'bg-neutral-100'}`} />
      <span className={`${STUDIO_THEME.typography.sectionLabel} flex items-center gap-2 ${darkMode ? 'text-white/40' : 'text-neutral-900/40'}`}>
        {icon && <i className={`fa-solid ${icon} text-[10px] opacity-100`}></i>}
        {children}
        {(tooltip || settingKey) && <InfoPopup content={tooltip || ""} settingKey={settingKey} modes={modes} darkMode={darkMode} />}
      </span>
      <div className={`flex-1 h-px ${darkMode ? 'bg-white/5' : 'bg-neutral-100'}`} />
    </div>
  );
};
